export default "__VITE_ASSET__DdUxoK5___"